/* SEARCH PLACEHOLDER */
//$('header #edit-search').attr('placeholder','Search');
//$('footer #edit-search').attr('placeholder','Search');

// FOOTER //
var eventFired = 0;

$(window).on("load resize", function () {
  if (window.matchMedia("(max-width: 991px)").matches) {
    if (!eventFired) {
      $(".middle-footer .right > ul > li").removeClass("col-6");
      $(".middle-footer .right > ul > li").addClass("go-back");
      $(".middle-footer .right > ul > li ul").css("display", "none");
      $(".middle-footer .right > ul > li").appendTo(".middle-footer .left ul");

      $(".middle-footer .left > ul > li:eq(5)").insertBefore(
        $(".middle-footer .left > ul > li:eq(1)")
      );
      $(".middle-footer .left > ul > li:eq(6)").insertBefore(
        $(".middle-footer .left > ul > li:eq(5)")
      );

      eventFired = 1;
    }
  } else {
    $(".middle-footer .left > ul > li.go-back").addClass("col-6");
    $(".middle-footer .left > ul > li.go-back").appendTo(
      ".middle-footer .right ul"
    );
    $(".middle-footer .right > ul > li ul").css("display", "block");

    eventFired = 0;
  }
});


/***
 * CookiesConsent
 * -----------------------------------------------
 */

/*
var _paq = (window._paq = window._paq || []);
_paq.push(["trackPageView"]);
_paq.push(["enableLinkTracking"]);
(function () {
  var u = "//science.matomo.cloud/";
  _paq.push(["setTrackerUrl", u + "matomo.php"]);
  _paq.push(["setSiteId", "2"]);
  _paq.push(["setDoNotTrack", "1"]);
  _paq.push(['requireCookieConsent']);
  var d = document,
    g = d.createElement("script"),
    s = d.getElementsByTagName("script")[0];
  g.async = true;
  g.src = u + "matomo.js";
  s.parentNode.insertBefore(g, s);
})();
*/

/*
window.cookies = new CookiesConsent({
  cookies: [
    {
      name: "analytics",
      init: function () {
        _paq.push(['rememberCookieConsentGiven']);
      },
      destroy: function () {
        _paq.push(['forgetCookieConsentGiven']);
        window.cookies.removeCookiesStartWith(["_pk", "MATOMO"]);
      },
    },
    {
      name: "social",
      init: function () {

        jQuery('.cookie-social-hide').hide();

        //Init Facebook pixel
        !function(f,b,e,v,n,t,s)    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?    n.callMethod.apply(n,arguments):n.queue.push(arguments)};    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';    n.queue=[];t=b.createElement(e);t.async=!0;    t.src=v;s=b.getElementsByTagName(e)[0];    s.parentNode.insertBefore(t,s)}(window,document,'script',    'https://connect.facebook.net/en_US/fbevents.js');    fbq('init', '2816927964984608');    fbq('track', 'PageView');

        //Init elfsight
        var d = document,
          g = d.createElement("script"),
          s = d.getElementsByTagName("script")[0];
        g.defer = true;
        g.src = "https://apps.elfsight.com/p/platform.js";
        s.parentNode.insertBefore(g, s);
      },
      destroy: function () {
        window.cookies.removeCookiesStartWith(["_fb", "_p_hfp"]);
      },
    },
  ],
});
*/

var menu = new Menu();

$("header #edit-search").attr("placeholder", Drupal.t("Search"));
$("footer #edit-search").attr("placeholder", Drupal.t("Search"));

/* SEARCH */
$(window).click(function () {
  $(".search-header #edit-key").removeClass("show");
  $(".search-header-icon").removeClass("hide");
});

$(window).scroll(function () {
  $(".search-header #edit-key").removeClass("show");
  $(".search-header-icon").removeClass("hide");
});

$(".search-wrapper").click(function (event) {
  event.stopPropagation();
});

$(".search-header-icon").click(function () {
  $(".search-header #edit-key").addClass("show");
  $(".search-header #edit-key").focus();
  $(this).addClass("hide");
});

/* BIG MENU */

$(".big-menu-link").click(function () {
  // hide after active ??? $('.bottom-header nav .is-active').addClass('hide');

  if ($(this).next(".big-menu-content").hasClass("show")) {
    $(this).next(".big-menu-content").removeClass("show");
    $("body").removeClass("show");
    $(".big-menu-link").removeClass("is-focus");
  } else {
    $(".big-menu-content").removeClass("show");
    $(this).next(".big-menu-content").addClass("show");
    $("body").addClass("show");
    $(".big-menu-link").removeClass("is-focus");
    $(this).addClass("is-focus");
  }
});

$(".bg-big-menu").click(function () {
  $("body").removeClass("show");
  $(".big-menu-content").removeClass("show");
  $(".big-menu-link").removeClass("is-focus");
});

/* GO TO TOP */

$("a[href='#top']").click(function () {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
});

/* SWIPER EVENTS HOMEPAGE */

var swiper = new Swiper(".swiper-container-events", {
  slidesPerView: 3,
  paginationClickable: true,
  spaceBetween: 50,
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",

  breakpoints: {
    // when window width is <= 480px
    767: {
      slidesPerView: 1,
    },
    // when window width is <= 640px
    991: {
      slidesPerView: 2,
    },
  },
});

/* SWIPER DIAPORAMA ARTICLE */

var swiper = new Swiper(".swiper-container-diaporama", {
  slidesPerView: "auto",
  paginationClickable: true,
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
  loop: false,
});

/* SWIPER GALLERY ARTICLE */

var swiper = new Swiper(".swiper-container-gallery", {
  slidesPerView: "auto",
  paginationClickable: true,
  spaceBetween: 50,
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
  loop: true,
  autoHeight: true,
  effect: "fade",
  paginationType: "fraction",
  pagination: ".swiper-pagination",
});

/* LIGHTBOX DIAPORAMA ARTICLE */

$(document).swipebox({ selector: ".swipebox" });

/* FAQ ACCORDION */
jQuery(document).ready(function () {

  $('.paragraph--type--faq .accordion').each(function(index, element){
    new Accordion(element);
  });

  /*
  if ($(".paragraph--type--faq .accordion").length > 0) {
    var el = document.querySelector(".paragraph--type--faq .accordion");
    new Accordion(el);
  }*/

  $('.infoboxes .accordion').each(function(index, element){
    new Accordion(element);
  });

  /*
  if ($(".infoboxes .accordion").length > 0) {
    var el = document.querySelector(".infoboxes .accordion");
    new Accordion(el);
  }*/

  $('.paragraph--type--infoboxes .accordion').each(function(index, element){
    new Accordion(element);
  });
  /*
  if ($(".paragraph--type--infoboxes .accordion").length > 0) {
    var el = document.querySelector(".paragraph--type--infoboxes .accordion");
    new Accordion(el);
  }
   */

});

/* TIME AGO */
jQuery(document).ready(function () {
  console.log(Drupal);

  if ($("html").attr("lang") == "de") {
    $.timeago.settings.strings = {
      prefixAgo: "vor",
      prefixFromNow: "in",
      suffixAgo: "",
      suffixFromNow: "",
      seconds: "wenigen Sekunden",
      minute: "etwa einer Minute",
      minutes: "%d Minuten",
      hour: "etwa einer Stunde",
      hours: "%d Stunden",
      day: "etwa einem Tag",
      days: "%d Tagen",
      month: "etwa einem Monat",
      months: "%d Monaten",
      year: "etwa einem Jahr",
      years: "%d Jahren",
    };
  }

  if ($("html").attr("lang") == "fr") {
    $.timeago.settings.strings = {
      // environ ~= about, it's optional
      prefixAgo: "il y a",
      prefixFromNow: "d'ici",
      seconds: "moins d'une minute",
      minute: "une minute",
      minutes: "%d minutes",
      hour: "une heure",
      hours: "%d heures",
      day: "un jour",
      days: "%d jours",
      month: "un mois",
      months: "%d mois",
      year: "un an",
      years: "%d ans",
    };
  }

  if ($("html").attr("lang") == "en") {
    $.timeago.settings.strings = {
      // environ ~= about, it's optional
      prefixAgo: null,
      prefixFromNow: null,
      suffixAgo: "ago",
      suffixFromNow: "from now",
      seconds: "less than a minute",
      minute: "about a minute",
      minutes: "%d minutes",
      hour: "about an hour",
      hours: "about %d hours",
      day: "a day",
      days: "%d days",
      month: "about a month",
      months: "%d months",
      year: "about a year",
      years: "%d years",
      wordSeparator: " ",
      numbers: [],
    };
  }

  $(".timeago").timeago();

  /********************
      RESEARCHERS DAYS JS
    ********************/

  /* SWIPER DIAPORAMA  */

  var swiperResearchers = new Swiper(".swiper-container-diaporama-researchers", {
    slidesPerView: "auto",
    paginationClickable: true,
    spaceBetween: 50,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    loop: true
  });

  if ($(".swiper-container-diaporama-researchers").length > 0) {
    swiperResearchers.on('onSlideChangeStart', function () {
      $('.swiper-slide').each(function () {
          $(this).find('iframe').attr( 'src', function ( i, val ) { return val; });
      });
    });
  }

  /* ACCORDION PROGRAM */

  var $accordionProgram = $("#accordionProgram");
  $accordionProgram.find('.collapse').on("show.bs.collapse", function () {
    console.log('collaspe show');
    $accordionProgram.find(".collapse.show").collapse("hide");
  });

  /* FORM INSCRIPTION CHECKBOX */

  if ($(".form-check").has(".option").length) {
    $("<span></span>").insertBefore(".form-check .option");
  }

  $('.js-webform-radios .form-check').each(function(index, element){

    $("<span></span>").insertBefore($(this).find('.label-radio'));

  });


  /* MAPBOX */

  if ($("#mapbox").length) {
    var geojson = {
      features: [
        {
          geometry: {
            coordinates: [5.947437, 49.499898],
          },
        },
      ],
    };

    mapboxgl.accessToken =
      "pk.eyJ1IjoiZXhwbG9zZSIsImEiOiJjazh6djY5b2QxbTJhM2lvN21wbjRtZGh6In0.V7Wa9jkvQ6S2A12n2Qzcqw";
    var map = new mapboxgl.Map({
      container: "mapbox",
      style: "mapbox://styles/explose/ck8zv7o880rrt1imn6p54o2d2",
      center: [5.947437, 49.499898],
      zoom: 13,
      attributionControl: true,
    });
    map.addControl(new mapboxgl.NavigationControl());
    map.scrollZoom.disable();

    // add markers to map
    geojson.features.forEach(function (marker) {
      // create a HTML element for each feature
      var el = document.createElement("div");
      el.className = "marker";

      // make a marker for each feature and add to the map
      new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
    });
  }
});

Drupal.behaviors.myBehavior = {
  attach: function (context, settings) {
    /*
        $('.card-actor .btn').on("focus", function (e) {

            setTimeout(function(){
                $(this).parentsUntil($(".card-container")).addClass('open-actor');
            }.bind(this),100);

        });
        */

    $(".step-three-de .form-managed-file .js-form-submit").attr(
      "value",
      "Löschen"
    );
    $(".step-three-fr .form-managed-file .js-form-submit").attr(
      "value",
      "Retirer"
    );
  },
};

$(".paragraph--type--files .file a").prepend("<i class='fa fa-download'></i>");
$(".paragraph--type--files .file a").attr("target", "_blank");

/*
 $('#mc_embed_signup_scroll .input-group').click(function() {
 if ($("#mc_embed_signup_scroll .input-group li input").is(':checked')) {
 console.log('titi');
 $('#mc_embed_signup_scroll .square-btn').addClass('show');
 }
 });
 */

/*
$('#mc-embedded-subscribe').click(function() {
    //$('div.mce_inline_error').remove();
    console.log('test');
    $('.lang-fr div.mce_inline_error').text('Ce champ est obligatoire');
    $('.lang-de div.mce_inline_error').text('Dies ist ein Pflichtfeld');
});

$('<p class="error-newsletter">Ce champ est obligatoire</p>').appendTo('.lang-fr #mc_embed_signup_scroll .mc-field-group');
$('<p class="error-newsletter">Dies ist ein Pflichtfeld</p>').appendTo('.lang-de #mc_embed_signup_scroll .mc-field-group');

$('#mc-embedded-subscribe').click(function() {
    setTimeout(function() {
        if ($('#mc_embed_signup_scroll li .required').hasClass('mce_inline_error')) {
            $('.input-group .error-newsletter').addClass('show');
        } else {
            $('.input-group .error-newsletter').removeClass('show');
        }
    }, 10);
});

$("#mc_embed_signup_scroll .input-group li input").click(function(){
    if ($("#mc_embed_signup_scroll .input-group li input").is(':checked')) {
        $('.input-group .error-newsletter').removeClass('show');
    };
});
*/

/*if ($('#mc_embed_signup_scroll #mce-EMAIL').hasClass('mce_inline_error')) {
    $('#mce-EMAIL + .error-newsletter').addClass('show');
} else {
    $('#mce-EMAIL + .error-newsletter').removeClass('show');
}
*/

jQuery(document).ready(function ($) {
  $('[data-program]').each(function(i, program){

    //Form

    var form = $(program).find('form');
    $(form).find('[name=category]').change(function(){
      filter();
    });
    $(form).find('select').change(function(){
      filter();
    });



    var filter = () => {
      console.log('filter');

      /*
      var category = 'all';
      category = $(form).find('[name=category]:checked').val();
      */

      var dates = $(form).find('[name=dates]').val();
      var languages = $(form).find('[name=languages]').val();
      var ages = $(form).find('[name=ages]').val();
      var domains = $(form).find('[name=domains]').val();

      console.log(languages);


      $( program ).find('[data-program-item]').hide();

      $( program ).find('[data-program-item]')
        .filter(function( index, item ) {

          var date_flag = false;
          var language_flag = false;
          var age_flag = false;
          var domain_flag = false;

          /*Category*/
          /*
          if (category != 'all'){
            if ($(item).data('category') != category){
              flag = false;
            }
          }
            */

          /*Dates*/
          if (dates.length > 0){

            var date_flag = false;
            var item_dates = $(item).data('dates').split(',');
            item_dates.forEach(function(date){
              if (dates.includes(date) && date != ''){
                date_flag = true;
              }
            });
          }else{
            date_flag = true;
          }

          /*Languages*/
          if (languages.length > 0){
            var language_flag = false;
            var item_languages = $(item).data('languages').split(',');
            item_languages.forEach(function(language){
              if (languages.includes(language) && language != ''){
                language_flag = true;
              }
            });
          }else{
            language_flag = true;
          }

          /*Ages*/
          if (ages.length > 0){
            if (ages.includes($(item).data('age'))){
              age_flag = true;
            }
          }else{
            age_flag = true;
          }

          /*Ages*/
          if (domains.length > 0){

            var item_domains = $(item).data('domains').split(',');
            item_domains.forEach(function(domain){
              if (domains.includes(domain) && domain != ''){
                domain_flag = true;
              }
            });
          }else{
            domain_flag = true;
          }

          return date_flag && language_flag && age_flag && domain_flag;
        })
        .show();

      if($( program ).find('[data-program-item]:visible').length == 0){
        $( program ).find('[data-empty]').show();
      }else{
        $( program ).find('[data-empty]').hide();
      }

    }

  });

  $('.program-wrapper').each(function(index, program){

    $(program).find('.collapse').on('hide.bs.collapse', function () {
      // do something…
      console.log('hidden');
      $(this).parent().find('.description-dotdotdot').show();
    });

    $(program).find('.collapse').on('show.bs.collapse', function () {
      // do something…
      console.log('show');
      $(this).parent().find('.description-dotdotdot').hide();
    });

  });



}(jQuery));

